import Store from "../";
import Mutations from "../mutations";
import { Promise } from "es6-promise";
import common from "../api/ajax";
import utils from '@/lib/utils';

const accountinghomeliabilityModule = {
  namespaced: true,
  state: {
    accountingHomeLiabilitys: [],
    packageTemplates: [],
    packageTemplateDetails: {},
    search_result_accounting_home_liabilitys: [],
    search_result_accounting_home_liabilitys_detail: []
  },
  getters: {
    ACCOUNTING_HOME_LIABILITY_LIST: state => {
      return state.accountingHomeLiabilitys;
    },
    SEARCH_ACCOUNTING_HOME_LIABILITY_LIST: state => {
      return state.search_result_accounting_home_liabilitys;
    },
    SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL: state => {
      return state.search_result_accounting_home_liabilitys_detail;
    }
  },
  mutations: {
    GET_ACCOUNTING_HOME_LIABILITY_LIST: (state, payload) => {
      let accountingHomeLiabilitys = payload.results;
      Store.state.pagination.total = payload.count;
      Store.state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      Store.state.pageArrow.prev = payload.previous;
      Store.state.pageArrow.next = payload.next;
      state.accountingHomeLiabilitys = accountingHomeLiabilitys;
      Mutations.setPaginator(Store.state, Store.state.pagination);
    },

    SEARCH_ACCOUNTING_HOME_LIABILITY_LIST: (state, payload) => {
      state.search_result_accounting_home_liabilitys = payload;
    },
    SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL: (state, payload) => {
      state.search_result_accounting_home_liabilitys_detail = payload;
    }
  },
  actions: {
    GET_ACCOUNTING_HOME_LIABILITY_LIST: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.getRequest(
          `/api/v1/${utils.getProjectId()}/accountinghomeliability/`,
          payload,
          function(res) {
            if (payload != null) {
              res.data["page"] = payload.params.page;
            }
            context.commit("GET_ACCOUNTING_HOME_LIABILITY_LIST", res.data);
            resolve(res);
          },
          function(error) {
            reject(error);
          },
          600000
        );
      });
    },
    ADD_ACCOUNTING_HOME_LIABILITY: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `/api/v1/${utils.getProjectId()}/accountinghomeliability/`,
          payload.data,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    UPDATE_ACCOUNTING_HOME_LIABILITY: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.putRequest(
          `/api/v1/${utils.getProjectId()}/accountinghomeliability/${payload.id}/`,
          payload.data,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    DELETE_ACCOUNTING_HOME_LIABILITY: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.deleteRequest(
          `api/v1/${utils.getProjectId()}/accountinghomeliability/${payload.id}/`,
          {},
          function(res) {
            resolve(res);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },

    SEARCH_ACCOUNTING_HOME_LIABILITY_LIST: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `api/v1/${utils.getProjectId()}/accountinghomeliability/search_accounting_home_liability/`,
          payload,
          function(res) {
            context.commit("SEARCH_ACCOUNTING_HOME_LIABILITY_LIST", res.data);
            resolve(res.data);
          },
          function(error) {
            reject(error);
          },
          60000
        );
      });
    },
    SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `api/v1/${utils.getProjectId()}/accountinghomeliability/search_accounting_home_liability_detail/`,
          payload,
          function(res) {
            context.commit(
              "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL",
              res.data
            );
            resolve(res.data);
          },
          function(error) {
            reject(error);
          },
          60000
        );
      });
    },
    INSERT_ACCOUNTING_HOME_LIABILITY: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `api/v1/${utils.getProjectId()}/accountinghomeliability/update_accounting_home_liability/`,
          payload,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          },
          60000
        );
      });
    }
  }
};
export default accountinghomeliabilityModule;



// WEBPACK FOOTER //
// ./src/store/modules/accountinghomeliability.js